import { request } from '@/api/request';

export type OrgBasic = {
  name: string;
  logoURL: string;
  location: string;
  connectionId: string;
  id: string;
};

const fetchSuppliersBasicList = () => request<OrgBasic[]>('GET', '/suppliers/basic');

type PrivateSupplier = {
  supplierId: string;
  supplierName: string;
  toggledPrivateAt: string;
  toggledPrivateBy: string;
};

type PrivateSuppliersResponse = {
  privateSuppliers: PrivateSupplier[];
};

const getPrivateSuppliers = () => request<PrivateSuppliersResponse>('GET', '/suppliers/private');

export default {
  fetchSuppliersBasicList,
  getPrivateSuppliers,
};
